import { createTV } from "tailwind-variants";
import type { ClassValue } from "tailwind-variants";

const tv = createTV({ twMerge: true, twMergeConfig: {} });

export const tw = (base: ClassValue, ...className: ClassValue[]) => {
  return tv({ base })({ className });
};
